function SkeletonLoader() {
    return (
      <div style={styles.container}>
        <div style={styles.skeleton} />
      </div>
    );
  }
  
  const styles = {
    container: {
      padding: '20px',
      textAlign: 'center',
    },
    skeleton: {
      width: '80%',
      height: '20px',
      margin: '10px auto',
      backgroundColor: '#e0e0e0',
      borderRadius: '4px',
      animation: 'pulse 1.5s infinite',
    },
  };
  
  // Keyframes for animation (CSS-in-JS version)
  const styleSheet = document.styleSheets[0];
  const keyframes =
  `@keyframes pulse {
    0% { opacity: 1; }
    50% { opacity: 0.5; }
    100% { opacity: 1; }
  }`;
  styleSheet.insertRule(keyframes, styleSheet.cssRules.length);
  
  export default SkeletonLoader;
  